/* VÆLD — ambient particle field.
   Drives every <canvas data-particles> on the page. Soft, slow motes
   that drift upward like embers / fog through unknown space.

   Per-canvas tuning via data attributes:
     data-density   particle multiplier      (default 1)
     data-opacity   peak brightness 0–1      (default 0.18)
     data-speed     drift speed multiplier   (default 1)
     data-direction "up" | "down"            (default up)

   Performance: capped count, single rAF per canvas, paused when the
   tab is hidden, disabled entirely under prefers-reduced-motion. */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvases = document.querySelectorAll('canvas[data-particles]');
  if (!canvases.length) return;

  Array.prototype.forEach.call(canvases, setup);

  function setup(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0;
    var particles = [];
    var rafId = null;
    var running = true;

    var density = parseFloat(canvas.dataset.density) || 1;
    var peak = parseFloat(canvas.dataset.opacity);
    if (isNaN(peak)) peak = 0.18;
    var speed = parseFloat(canvas.dataset.speed) || 1;
    var up = (canvas.dataset.direction || 'up') !== 'down';

    function resize() {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function reset(p, anywhere) {
      p.x = Math.random() * w;
      p.y = anywhere ? Math.random() * h : (up ? h + 12 : -12);
      p.r = 0.5 + Math.random() * 2.4;
      p.vx = (Math.random() - 0.5) * 0.12 * speed;
      p.vy = (0.05 + Math.random() * 0.28) * speed * (up ? -1 : 1);
      p.a = peak * (0.2 + Math.random() * 0.8);
      p.tw = Math.random() * Math.PI * 2;
      p.tws = 0.004 + Math.random() * 0.012;
      p.sway = Math.random() * Math.PI * 2;
      p.swayAmp = 0.03 + Math.random() * 0.09;
      return p;
    }

    function build() {
      var base = (w * h) / 24000;
      var count = Math.min(180, Math.max(20, Math.round(base * density)));
      particles = [];
      for (var i = 0; i < count; i++) particles.push(reset({}, true));
    }

    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.sway += 0.005;
        p.tw += p.tws;
        p.x += p.vx + Math.sin(p.sway) * p.swayAmp;
        p.y += p.vy;

        if (up && p.y < -14) reset(p, false);
        else if (!up && p.y > h + 14) reset(p, false);
        if (p.x < -14) p.x = w + 12;
        else if (p.x > w + 14) p.x = -12;

        var twinkle = 0.5 + Math.sin(p.tw) * 0.5;
        var alpha = p.a * twinkle;
        if (alpha <= 0.002) continue;

        // Soft halo
        var rad = p.r * 4.5;
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, rad);
        g.addColorStop(0, 'rgba(255,255,255,' + (alpha * 0.7).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x, p.y, rad, 0, Math.PI * 2);
        ctx.fill();

        // Crisp star core
        ctx.fillStyle = 'rgba(255,255,255,' + Math.min(1, alpha * 1.6).toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(p.x, p.y, Math.max(0.4, p.r * 0.55), 0, Math.PI * 2);
        ctx.fill();
      }

      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId) return;
      running = true;
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    resize();
    build();

    requestAnimationFrame(function () {
      canvas.classList.add('is-ready');
      start();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { resize(); build(); }, 200);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
  }
})();
